export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_REQUEST_SUCCESS = "GET_USERS_REQUEST_SUCCESS";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_REQUEST_SUCCESS = "CREATE_USER_REQUEST_SUCCESS";
export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_REQUEST_SUCCESS = "DELETE_USER_REQUEST_SUCCESS";

export const getUsers = () => ({
    type: GET_USERS_REQUEST
});

export const createUser = (username, password, email) => ({
    type: CREATE_USER_REQUEST,
    payload: {
        username,
        password,
        email
    }
});


export const deleteUser = (payload) => ({
    type: DELETE_USER_REQUEST,
    payload
});